import React from 'react';
import { Button } from './ui/button';
import { Sparkles } from 'lucide-react';

const heroData = {
  headline: "Confidence Starts With Support",
  subheadline: "Premium shapewear and waist trainers designed for real women, real bodies, and real transformation.",
  cta: "Shop Now"
};

const HeroSection = () => {
  return (
    <section className="hero-section hero-gradient min-h-[85vh] flex items-center justify-center relative">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-64 h-64 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-8 shadow-sm animate-fade-in">
            <Sparkles className="w-4 h-4 accent-gold" />
            <span className="text-sm font-sans font-medium text-foreground">EMPOWERING WOMEN EVERYWHERE</span>
          </div>

          {/* Main headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif font-semibold text-foreground mb-6 leading-tight animate-fade-in animate-delay-100">
            {heroData.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-muted-foreground font-sans max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in animate-delay-200">
            {heroData.subheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in animate-delay-300">
            <Button 
              size="lg" 
              className="bg-accent-gold hover:bg-accent-gold/90 text-white font-sans font-semibold text-sm tracking-wider px-8 py-6 rounded-lg shadow-lg hover-lift"
            >
              {heroData.cta}
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-2 border-foreground text-foreground hover:bg-foreground hover:text-white font-sans font-semibold text-sm tracking-wider px-8 py-6 rounded-lg"
            >
              Learn More
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-muted-foreground text-sm font-sans animate-fade-in animate-delay-300">
            <div className="flex items-center gap-2">
              <span className="text-2xl">★★★★★</span>
              <span>5,000+ Reviews</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-border"></div>
            <div>Free Shipping Over $50</div>
            <div className="hidden sm:block w-px h-6 bg-border"></div>
            <div>30-Day Guarantee</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
